/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
  document.addEventListener('theme:variant:change', function (evt) {
    console.log("Variant change ->" + evt.detail.variant.id);

    let variant = evt.detail.variant;

    // Update stock availability
    let variantId = variant.id;

    let $availability = document.querySelector('.inventory-availability');
    $availability.innerHTML = stockAvailability[variantId]["stock_availability"];

  });
  




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
